<template>
  <product-header :heading="$t(`prompt_reset_password.heading`)" />
  <paragraph-content keypath="prompt_reset_password.paragraph" :email="user?.email" />
  <vertical-stack class="button-container">
    <large-button type="submit" @click="redirectToResetPassword">
      {{ $t('prompt_reset_password.continue') }}
    </large-button>
    <drone-button :glyph="GlyphType.Arrow" @click="emit('skip')">
      {{ $t('prompt_reset_password.skip') }}
    </drone-button>
  </vertical-stack>
</template>

<script setup>
import { watch } from 'vue';
import { VerticalStack, LargeButton, DroneButton, GlyphType, useAuthentication } from 'ihunter-pathfinder-components';
import ProductHeader from '../components/ProductHeader.vue';
import ParagraphContent from '../components/ParagraphContent.vue';
import { useRouteManager } from '../composables/useRouteManager';

const { user } = useAuthentication();
const { redirectToResetPassword } = useRouteManager();

const emit = defineEmits(['skip']);
</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;
@use '../styles/Accounts' as Accounts;

@include Accounts.Default;

.vertical-stack {

  .button-container {
    margin-top: Pathfinder.$space-500;
    align-items: center;
  }

  @include Pathfinder.below(min) {
    .button-container {
      margin-top: Pathfinder.$space-400;
    }
  }
}
</style>